import { Heading } from 'bold-ui'
import { useAlert } from 'components/alert'
import { useErrorHandler } from 'components/error'
import { PageContainer } from 'components/layout/PageContainer'
import { PageContent } from 'components/layout/PageContent'
import {
  useBuscaCidadaoCadsusLazyQuery,
  useBuscaCidadaoCadsusPollingQuery,
  useBuscaCidadaosCadsusCompletoSubscription,
  useCidadaoListingLazyQuery,
  useConfiguracaoCadsusQuery,
} from 'graphql/hooks.generated'
import {
  BuscaCidadaosCadsusCompletoSubscription,
  CidadaoListingQuery,
  SincronizacaoCadsusResultEnum,
} from 'graphql/types.generated'
import qs from 'qs'
import React, { useCallback, useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router'
import { v4 as uuidv4 } from 'uuid'

import CidadaoPesquisarFormModel from '../types/CidadaoPesquisarFormModel'
import { CidadaoUrlParams } from '../types/CidadaoUrlParams'
import { CidadaoListItemView } from './CidadaoListItemView'
import { CidadaoPesquisarForm } from './CidadaoPesquisarForm'

export type CidadaoCadsusItemType = BuscaCidadaosCadsusCompletoSubscription['buscaCidadaosCadsusCompleto']['cidadaos'][0]
export type CidadaoItemType = CidadaoListingQuery['cidadaos']['content'][0]

let pollingCadsus = false

export function CidadaoListView() {
  sessionStorage.removeItem('cidadaoCadsus')
  const alert = useAlert()
  const location = useLocation()
  const history = useHistory()
  const handleRejection = useErrorHandler()

  const [cidadaoUrlParamsState] = useState<CidadaoUrlParams>(
    qs.parse(location.search, {
      ignoreQueryPrefix: true,
    })
  )

  const [hasCadsusCalled, setHasCadsusCalled] = useState(false)
  const [isCadsusLoading, setIsCadsusLoading] = useState<boolean>(false)
  const { data: configCadsus } = useConfiguracaoCadsusQuery()
  const [buscaListaCadsusLazyQuery] = useBuscaCidadaoCadsusLazyQuery()
  const [hashBuscaCadsus, setHashBuscaCadsus] = useState<string>()

  const alertaUsuario = useCallback(
    (message: string) => {
      alert('warning', message)
    },
    [alert]
  )

  const processResultCadsus = useCallback(
    (data) => {
      pollingCadsus = false
      setIsCadsusLoading(false)
      setCadsusDataState(data.cidadaos)
      if (SincronizacaoCadsusResultEnum.SUCESSO === data.resultCadsus) {
        if (!data?.cidadaos?.length) {
          alertaUsuario(
            'Não foram encontrados resultados com os filtros selecionados. Refine a busca incluindo mais informações.'
          )
        } else if (data?.cidadaos?.length === 20) {
          alert(
            'info',
            'Foram encontrados muitos cadastros com os dados informados. Refine a busca incluindo mais informações.'
          )
        }
      } else if (SincronizacaoCadsusResultEnum.ERRO_SEM_CONEXAO === data.resultCadsus) {
        alertaUsuario(
          'Não foi possível buscar na base nacional, pois a instalação está offline.' +
            ' Entre em contato com o responsável pela instalação para mais informações.'
        )
      } else if (SincronizacaoCadsusResultEnum.ERRO_CADSUS_DESABILITADO === data.resultCadsus) {
        alertaUsuario(
          'Não foi possível buscar na base nacional, pois a conexão com o serviço está desabilitada.' +
            ' Entre em contato com o responsável pela instalação para mais informações.'
        )
      } else if (SincronizacaoCadsusResultEnum.ERRO === data.resultCadsus) {
        alertaUsuario('Não foi possivel se conectar ao sistema do CADSUS')
      } else if (SincronizacaoCadsusResultEnum.LENTO === data.resultCadsus) {
        alertaUsuario('O serviço de consulta está momentaneamente sobrecarregado, tente novamente em alguns instantes.')
      }
      setHasCadsusCalled(true)
    },
    [alert, alertaUsuario]
  )

  const { refetch: refetchPolling } = useBuscaCidadaoCadsusPollingQuery({ skip: true })

  useBuscaCidadaosCadsusCompletoSubscription({
    onSubscriptionData: (options) => {
      const data = options?.subscriptionData?.data?.buscaCidadaosCadsusCompleto
      if (data?.uuid === hashBuscaCadsus && pollingCadsus) {
        processResultCadsus(data)
      }
    },
  })

  useEffect(() => {
    let shouldUpdate = true
    const scheduleCadsusPolling = setInterval(() => {
      if (!!hashBuscaCadsus && pollingCadsus && shouldUpdate) {
        shouldUpdate = false
        refetchPolling({ uuid: hashBuscaCadsus })
          .then(
            ({ data }) =>
              !!data.buscaCidadaosCadsusCompletoPolling &&
              data.buscaCidadaosCadsusCompletoPolling.uuid === hashBuscaCadsus &&
              pollingCadsus &&
              processResultCadsus(data.buscaCidadaosCadsusCompletoPolling)
          )
          .finally(() => (shouldUpdate = true))
          .catch(handleRejection)
      }
    }, 1 * 1000)

    return () => clearInterval(scheduleCadsusPolling)
  }, [handleRejection, hashBuscaCadsus, processResultCadsus, refetchPolling])

  const [pesquisaCadsusState, setPesquisacadsusState] = useState<CidadaoPesquisarFormModel>({})
  const [cadsusDataState, setCadsusDataState] = useState<CidadaoCadsusItemType[]>()

  const buscaCidadaoCadsus = () => {
    if (configCadsus.conexao.internet.habilitado) {
      if (configCadsus.conexao.cadsus.habilitado) {
        const hash = uuidv4()
        setHashBuscaCadsus(hash)
        setIsCadsusLoading(true)
        pollingCadsus = true
        buscaListaCadsusLazyQuery({
          variables: {
            filter: {
              query: {
                query: pesquisaCadsusState.nomeCpfCns,
                dataNascimento: pesquisaCadsusState.dataNascimento,
                nomeMae: pesquisaCadsusState.nomeMae,
                municipioNascimento: pesquisaCadsusState.municipio?.id,
                pageParams: {},
              },
              uuid: hash,
            },
          },
        })
      } else {
        alertaUsuario(
          'Não foi possível buscar na base nacional, pois a conexão com o serviço está desabilitada.' +
            ' Entre em contato com o responsável pela instalação para mais informações.'
        )
      }
    } else {
      alertaUsuario(
        'Não foi possível buscar na base nacional, pois a instalação está offline.' +
          ' Entre em contato com o responsável pela instalação para mais informações.'
      )
    }
  }

  const [executeQuery, { data, refetch }] = useCidadaoListingLazyQuery({
    onCompleted: (dataCidadaos) => {
      if (dataCidadaos?.cidadaos?.pageInfo.totalElements === 0) {
        alert('warning', 'Nenhum resultado encontrado')
        buscaCidadaoCadsus()
      }
      if (dataCidadaos?.cidadaos?.pageInfo.totalElements > 50) {
        alert(
          'info',
          'Foram encontrados muitos cadastros com os dados informados. Refine a busca incluindo mais informações.'
        )
      }
    },
  })

  const handleSubmitPesquisa = (form: CidadaoPesquisarFormModel) => {
    if (!form.nomeCpfCns && !form.dataNascimento && !form.nomeMae && !form.municipio) {
      alert('info', 'Insira algum filtro para realizar a busca')
    } else {
      pesquisar(form)
      history.push({
        search: qs.stringify({
          callbackUrl: cidadaoUrlParamsState.callbackUrl,
          callbackParams: cidadaoUrlParamsState.callbackParams,
          form: form,
        }),
      })
    }
  }

  const pesquisar = useCallback(
    (form: CidadaoPesquisarFormModel | undefined) => {
      setCadsusDataState(null)
      setPesquisacadsusState({
        nomeCpfCns: form?.nomeCpfCns,
        dataNascimento: form?.dataNascimento,
        municipio: form?.municipio,
        nomeMae: form?.nomeMae,
      })
      setHasCadsusCalled(false)
      executeQuery({
        variables: {
          filtro: {
            pageParams: {
              size: 50,
            },
            query: form?.nomeCpfCns,
            dataNascimento: form?.dataNascimento,
            nomeMae: form?.nomeMae,
            municipioNascimento: form?.municipio?.id,
            ativo: cidadaoUrlParamsState.callbackUrl ? true : null,
            obito: cidadaoUrlParamsState.callbackUrl ? false : null,
          },
        },
      })
    },
    [cidadaoUrlParamsState.callbackUrl, executeQuery]
  )

  useEffect(() => {
    cidadaoUrlParamsState.form && pesquisar(cidadaoUrlParamsState.form)
  }, [cidadaoUrlParamsState, pesquisar])

  const refetchLocal = () => {
    refetch()
  }

  return (
    <>
      <PageContainer>
        <Heading style={{ padding: '2rem 0rem' }} level={1}>
          Cidadão
        </Heading>
        <CidadaoPesquisarForm handleSubmitPesquisa={handleSubmitPesquisa} initialValue={cidadaoUrlParamsState.form} />
      </PageContainer>
      <PageContent type='transparent' style={{ textAlign: 'center' }}>
        <CidadaoListItemView
          result={data}
          resultCadsus={cadsusDataState}
          loadingCadsus={isCadsusLoading}
          refetchLocal={refetchLocal}
          onBuscarClicked={buscaCidadaoCadsus}
          hasCadsusCalled={hasCadsusCalled}
          hasCadsusConnection={configCadsus.conexao?.cadsus?.habilitado}
          hasInternetConnection={configCadsus.conexao?.internet?.habilitado}
          cidadaoUrlParams={cidadaoUrlParamsState}
        />
      </PageContent>
    </>
  )
}
